import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class WrongCalculationMethodUsedOnDocumentError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.sale.validation.calculation-method.wrong-calculation-method-used-on-document');
    }
}
